const API_URL = process.env.VUE_APP_ENDPOINT_API;
import axios from 'axios';
import { authHeaders } from '@/services/session.js';

function unwrapPlotList (payload) {
    if (Array.isArray(payload)) {
        return payload;
    }
    if (payload && Array.isArray(payload.data)) {
        return payload.data;
    }
    if (payload && Array.isArray(payload.plots)) {
        return payload.plots;
    }
    if (payload && typeof payload === 'object') {
        const keys = Object.keys(payload);
        if (keys.length && keys.every((key) => /^\d+$/.test(key))) {
            return keys.sort((a, b) => Number(a) - Number(b)).map((key) => payload[key]);
        }
    }
    return [];
}

class PlotService {

    getPlots () {
        return new Promise((resolve, reject) => {
            axios({
                url: API_URL + 'pwa/plots',
                method: 'GET',
                headers: authHeaders(),
            }).then(resp => {
                resolve(unwrapPlotList(resp.data))
            })
            .catch(err => {
                reject(err.response === undefined ? err : err.response.data.message)
            })
        })
    }

    getPlot (id) {
        return new Promise((resolve, reject) => {
            axios({
                url: API_URL + 'pwa/plots/' + id,
                method: 'GET',
                headers: authHeaders(),
            }).then(resp => {
                resolve(resp.data)
            })
            .catch(err => {
                reject(err.response === undefined ? err : err.response.data.message)
            })
        })
    }
}

export default new PlotService ()
